import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore, isAdminRole, homeFor, type Role } from "./store/auth";
import { LoginPage } from "./pages/LoginPage";
import { InvitePage } from "./pages/InvitePage";
import { DashboardPage } from "./pages/DashboardPage";
import { ClassDetailPage } from "./pages/ClassDetailPage";
import { StudentDetailPage } from "./pages/StudentDetailPage";
import { OpsPage } from "./pages/OpsPage";
import { OpsOrgPage } from "./pages/OpsOrgPage";
import { SchoolPage } from "./pages/SchoolPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/" element={<RequireRole roles={["teacher"]}><DashboardPage /></RequireRole>} />
      <Route path="/classes/:id" element={<RequireRole roles={["teacher"]}><ClassDetailPage /></RequireRole>} />
      <Route path="/students/:id" element={<RequireRole roles={["teacher"]}><StudentDetailPage /></RequireRole>} />
      <Route path="/ops" element={<RequireRole roles={["system_admin"]}><OpsPage /></RequireRole>} />
      <Route path="/ops/orgs/:id" element={<RequireRole roles={["system_admin"]}><OpsOrgPage /></RequireRole>} />
      <Route path="/school" element={<RequireRole roles={["org-admin"]}><SchoolPage /></RequireRole>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

/** ログインしていなければ /login、役割が合わなければその人の最初の画面へ戻す */
function RequireRole({ roles, children }: { roles: Role[]; children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.accessToken);
  if (!user || !token || !isAdminRole(user.role)) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return <>{children}</>;
}
